export class FourthTab {
  deliveryType: string;
  homeDeliveryAvailableCourierSelectedDate: string;
  homeDeliveryCourierId: string;
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/classes/fourth-tab.model.ts